<template>
  <div
    class="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4"
    :style="`background-image: url('${baseUrl}vendor/img/bg/1.jpg');`"
  >
    <div class="ui-bg-overlay bg-dark opacity-25"></div>

    <div class="authentication-inner py-5">
      <b-card no-body>
        <div class="p-4 p-sm-5">
          <div class="d-flex justify-content-center align-items-center pb-2 mb-4">
            <div class="ui-w-60">
              <div class="w-100 position-relative" style="padding-bottom: 54%">
                <svg xmlns="http://www.w3.org/2000/svg" class="position-absolute" viewBox="0 0 80 80">
                  <path
                    d="M80 80L53.88 5.36C52.75 2.15 49.72 0 46.32 0H33.68c-3.4 0-6.43 2.15-7.55 5.36L0 80h24l16-45.71L56 80h24z"
                    class="fill-primary"
                  />
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="41.2207"
                    y1="30.5288"
                    x2="61.1847"
                    y2="37.0155"
                  >
                    <stop offset="0" stop-color="#010101" stop-opacity=".2" />
                    <stop offset=".3" stop-color="#010101" stop-opacity=".1" />
                    <stop offset=".85" stop-color="#010101" stop-opacity="0" />
                  </linearGradient>
                  <path
                    d="M51 65.71l12-34.29-9.12-26.06c-.5-1.43-1.39-2.63-2.51-3.54L40 34.29l11 31.42z"
                    fill="url(#a)"
                  />
                </svg>
              </div>
            </div>
          </div>

          <h4 class="text-center text-muted font-weight-normal mb-4 mt-5">{{ appTitleDefault }}</h4>
          <notifications group="notifications-default" />

          <b-alert v-if="erro" show variant="danger" class="text-center">
            {{ erro }}
          </b-alert>
          <div v-if="!erro">
            <h3>Você será redirecionado em instantes...</h3>
          </div>

          <div v-if="isLoading">
            <div class="text-center m-3">
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
          </div>
        </div>
        <b-card-footer class="py-3 px-4 px-sm-5" v-if="false">
          <div class="text-center text-muted">
            Não possui conta?
            <a @click="onSignUpTap" id="text-link-cadastrar">Cadastrar</a>
          </div>
        </b-card-footer>
      </b-card>
    </div>
  </div>
</template>

<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>

<script>
export default {
  name: 'pages-authentication-login-v2',

  metaInfo: {
    title: 'Login'
  },

  data() {
    return {
      isLoading: false,
      erro: ''
    };
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },
    appTitleDefault() {
      return process.env.VUE_APP_TITLE || 'Atena';
    }
  },

  mounted() {
    const authIntegration = {
      accessToken: this.$route.query.accessToken,
      refreshToken: this.$route.query.refreshToken,
      accessExpiresAt: this.$route.query.accessExpiresAt,
      refreshExpiresAt: this.$route.query.refreshExpiresAt
    };
    console.log('authIntegration', authIntegration);
    if (
      authIntegration.accessToken === undefined ||
      authIntegration.refreshToken === undefined ||
      authIntegration.accessExpiresAt === undefined ||
      authIntegration.refreshToken === undefined
    ) {
      this.erro = 'Parâmetros ausentes para realizar a Operação.';
      return;
    }

    this.isLoading = true;
    let authSuccess = this.$auth.integratedLogin(authIntegration);
    let self = this;
    authSuccess.then(function (result) {
      if (result) {
        self.loggedMessage();
        self.$router.push('/dashboard');
      } else {
        self.isLoading = false;
        self.erro = 'Erro ao realizar Login. Verifique os parâmetros enviados.';
        return;
      }
    });
  },

  methods: {
    loggedMessage() {
      this.$notify({
        group: 'notifications-default',
        type: 'success',
        title: 'Autenticação Completada',
        text: 'Bem-vindo de volta!'
      });
    },

    onForgetPassTap() {
      console.log('esqueci minha senha');
    },

    onSignUpTap() {
      console.log('cadastrar');
    }
  }
};
</script>

<style lang="scss" scoped>
#text-link-cadastrar {
  color: #3c8ae2;
}

#text-link-cadastrar:hover {
  text-decoration: underline;
  cursor: pointer;
}

#text-link-senha {
  color: #3c8ae2;
}

#text-link-senha:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
